import validate from "/app/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/app/frontend/middleware/01_auth.global.ts";
import _02_45access_45auth_45global from "/app/frontend/middleware/02_access_auth.global.ts";
import _03_45version_45control_45global from "/app/frontend/middleware/03_version_control.global.ts";
import ga4_45middleware from "/app/frontend/node_modules/@nuxt-alt/google-analytics/dist/runtime/middleware.mjs";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45access_45auth_45global,
  _03_45version_45control_45global,
  ga4_45middleware
]
export const namedMiddleware = {
  "has-test-works": () => import("/app/frontend/middleware/hasTestWorks.ts"),
  "my-journals-auth": () => import("/app/frontend/middleware/myJournalsAuth.ts"),
  "skip-login": () => import("/app/frontend/middleware/skipLogin.ts")
}